import React from 'react';
import "./ProductCard.css";
import { useLocation, useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const { title, brand, imageUrl, price, discountedPrice, color, discountPersent } = product;
  const navigate = useNavigate();

  // console.log("product",product)

  const handleNavigate = () => {
    navigate(`/product/${product?.id || product?._id || 2}`)
  }

  return (
    <div onClick={handleNavigate} className='productCard w-[18rem] border m-3 transition-all cursor-pointer rounded-lg overflow-hidden'>
      <div className='h-[22rem] bg-gray-50 flex items-center justify-center p-2'>
        <img className='h-full w-full object-contain' src={imageUrl} alt="" />
      </div>
      <div className='textPart bg-white p-3 '>
        <div>
          <p className='font-bold opacity-60'>{brand}</p>
          <p className=''>{title}</p>

          <p className='font-semibold opacity-50'>{color}</p>
        </div>

        <div className='flex space-x-2 items-center'>
          <p className='font-semibold'>${typeof discountedPrice === 'number' ? discountedPrice.toFixed(2) : discountedPrice}</p>
          {discountPersent > 0 && (
            <>
              <p className='opacity-50 line-through'>${typeof price === 'number' ? price.toFixed(2) : price}</p>
              <p className='text-green-600 font-semibold'>{discountPersent}% off</p>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default ProductCard;
